/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenRequest
 */
export interface TokenRequest {
    /**
     * 
     * @type {number}
     * @memberof TokenRequest
     */
    ttl: number;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    capability: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    clientId: string;
    /**
     * 
     * @type {number}
     * @memberof TokenRequest
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    keyName: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    nonce: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    mac: string;
}

/**
 * Check if a given object implements the TokenRequest interface.
 */
export function instanceOfTokenRequest(value: object): value is TokenRequest {
    if (!('ttl' in value) || value['ttl'] === undefined) return false;
    if (!('capability' in value) || value['capability'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('keyName' in value) || value['keyName'] === undefined) return false;
    if (!('nonce' in value) || value['nonce'] === undefined) return false;
    if (!('mac' in value) || value['mac'] === undefined) return false;
    return true;
}

export function TokenRequestFromJSON(json: any): TokenRequest {
    return TokenRequestFromJSONTyped(json, false);
}

export function TokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ttl': json['ttl'],
        'capability': json['capability'],
        'clientId': json['clientId'],
        'timestamp': json['timestamp'],
        'keyName': json['keyName'],
        'nonce': json['nonce'],
        'mac': json['mac'],
    };
}

export function TokenRequestToJSON(json: any): TokenRequest {
    return TokenRequestToJSONTyped(json, false);
}

export function TokenRequestToJSONTyped(value?: TokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ttl': value['ttl'],
        'capability': value['capability'],
        'clientId': value['clientId'],
        'timestamp': value['timestamp'],
        'keyName': value['keyName'],
        'nonce': value['nonce'],
        'mac': value['mac'],
    };
}

